var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    attrs: {
      "color": "transparent"
    }
  }, [_c('v-container', {
    staticClass: "container--large"
  }, [_vm.$vuetify.breakpoint.smAndUp ? _c('main-visual', {
    attrs: {
      "code": "lecture-pc"
    }
  }) : _c('main-visual', {
    attrs: {
      "code": "lecture-mobile"
    }
  })], 1), _c('main-section', {
    staticClass: "pb-0"
  }, [_c('lecture-categories')], 1), _vm._l(_vm.items, function (item, index) {
    var _class;
    return [_c('main-section', {
      key: index,
      class: (_class = {}, _class[item.className] = true, _class['pt-0'] = index == 0, _class)
    }, [_vm._l(item.categories, function (item) {
      return [_c('lecture-main-list', _vm._b({
        key: item._id
      }, 'lecture-main-list', item, false))];
    })], 2)];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }